<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật : {{ modelData.name}}<!--  / Khóa : {{ configData.course.name | courseName }} --></h2>
        <el-button @click="backModel" size="small" class="btn-back">
          Trờ về <!-- {{ configData.course.name | courseName }} -->
        </el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="10">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel" @submit.native.prevent>
            <el-form-item prop="name" label="Tên chương học" class="form-item">
              <el-input v-model="modelData.name" class="input-seach" ref="myInput"></el-input>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
              <el-button
                :disable="!canSubmit"
                :loading="!canSubmit"
                type="warning"
                size="small"
                @click="submitForm('createModel')">Cập nhật</el-button>
              <el-button
                size="small"
                class="btn-back"
                @click="backModel">Trở về
              </el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'ChapterUpdate',
  metaInfo () {
    return {
      title: 'Chương học | Cập nhật'
    }
  },
  components: {

  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        course_id: '',
        status: true
      },
      configData: {
        course: {
          id: 0,
          name: 'Tên khóa này'
        }
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập tên chương học' },
          { min: 2, max: 191, message: 'Tên chương học có chiều dài từ 2 tới 191 kí tự' }
        ]
      }
    }
  },
  mounted () {
    this.$refs.myInput.focus()
    this.fetchModel()
    this.configDataAndBreadcrumb()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình dữ liệu về khóa học, chương, cấu hình Breadcrumb
    configDataAndBreadcrumb () {
      this.modelData.course_id = this.$route.params.course_id
      this.fetchCourse()
    },
    fetchCourse () {
      axios.get('courses/' + this.$route.params.course_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.course = response.data
            this.configBreadcrumb()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'courses-index', text: 'Khóa học' },
        { name: 'courses-show', course_id: this.$route.params.course_id, text: this.configData.course.name },
        { name: 'chapters-index', text: 'Cập nhật chương học' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'courses-show', params: {course_id: this.$route.params.course_id}})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('chapters/' + this.$route.params.chapter_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    updateModel () {
      this.canSubmit = false
      axios.put('chapters/' + this.$route.params.chapter_id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật chương học thành công',
              type: 'success'
            })
            this.$router.push({name: 'courses-show', params: {course_id: this.$route.params.course_id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/chapters/Update.vue